import { FormControl, Select, MenuItem, Dialog, DialogContent, DialogTitle, IconButton, DialogActions, Checkbox, ListItemText } from "@mui/material";
import { FunctionComponent, useState } from "react";
import { AgentObj } from "../../Models/AgentObj";
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const AddAgent: FunctionComponent<{ onAddAgent: any }> = (props) => {

    const [agentValue, setAgentValue] = useState<AgentObj>({} as AgentObj);
    const [open, setOpen] = useState(false);
    const [emailError, setEmailError] = useState<string | null>(null);
    const [isAdd, setIsAdd] = useState<boolean>(false);
    let location: any = useLocation().pathname.split('/');
    const { t } = useTranslation();

    const handleClickOpen = () => {
        setAgentValue({} as AgentObj);
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const validateEmail = (email: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(email)) {
            setEmailError("Please enter a valid email address.");
            return false;
        }
        setEmailError(null);
        return true;
    }
    const HandleAddAgent = () => {
        if (!validateEmail(agentValue.email)) return;
        setOpen(false)
        setIsAdd(true)
        props.onAddAgent(agentValue).then(() => {
            setIsAdd(false);
        }).catch(() => {
            setIsAdd(false);
        });
    }

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setAgentValue((prev: any) => ({ ...prev, [name]: value }));
    }

    const handleChangeImgAgent = (event: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
            const base_64 = reader.result as string;
            setAgentValue((prev: any) => ({
                ...prev,
                image: base_64
            }));
        }
    }

    const handleSelectLanguge = (event: any) => {
        const { value } = event.target;

        const selectedLangs = typeof value === 'string'
            ? value.split(',')
            : (value as string[]);

        setAgentValue((prevOptions: any) => ({
            ...prevOptions,
            languages: selectedLangs
        }))
    }

    return (<>

        {location[1] === "settings" ?
            <button type="submit" className="button-dash back-746AFF color-FFFFFF  border-746AFF padd-15" onClick={handleClickOpen}>
                <svg width="16" height="16" className="size-20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_23_299)">
                        <path d="M8 3.33334V12.6667" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M3.33203 8H12.6654" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_23_299">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <span className="display-none-mb"> {t("propertyDetails.addAgent")}  </span> {isAdd && <div className="spinner-border size-20 text-white" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>}
            </button> : <button className="button-dash border-746AFF color-746AFF back-trans padd-15" onClick={handleClickOpen}>
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1117_1984)">
                        <path d="M8.30615 3.3335V12.6668" stroke="#746AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M3.63965 8H12.973" stroke="#746AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1117_1984">
                            <rect width="16" height="16" fill="white" transform="translate(0.306152)" />
                        </clipPath>
                    </defs>
                </svg>
                {isAdd && <div className="spinner-border size-20 text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>}
            </button>}


        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle >
                <div className="title-20 mt-2">{t("propertyDetails.addAgent")}</div>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[800],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <div className="row padd-00-20">
                    <div className="col-md-6 text-start  mb-3">
                        <label htmlFor="Name" className="form-label mb-3">{t("propertyDetails.fullName")}</label>
                        <input type="text" className="form-control custom-select" name="fullName" value={agentValue?.fullName || ""} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 text-start  mb-3">
                        <label htmlFor="Email Address" className="form-label mb-3">{t("propertyDetails.emailAddress")}</label>
                        <input type="email" className={`form-control custom-select ${emailError ? "is-invalid" : ""}`} name="email" value={agentValue?.email || ""} onChange={handleChange} />
                        {emailError && <div className="para-12 color-D80027 mt-2">{emailError}</div>}
                    </div>
                    <div className="col-md-6 text-start  mb-3">
                        <label htmlFor="Phone Number" className="form-label mb-3">{t("propertyDetails.phoneNumber")}</label>
                        <input type="number" className="form-control custom-select" name="phoneNumber" value={agentValue?.phoneNumber || ""} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 text-start  mb-3">
                        <label htmlFor="languages" className="form-label mb-3">{t("propertyDetails.languages")}</label>
                        <FormControl fullWidth>
                            <Select
                                className="form-control custom-select"
                                multiple
                                value={agentValue?.languages ?? []}
                                onChange={handleSelectLanguge}
                                renderValue={(selected) => selected.map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(', ')}
                            >
                                <MenuItem key="english" value="english">
                                    <Checkbox checked={agentValue?.languages?.includes("english") ?? false} />
                                    <ListItemText primary="English" />
                                </MenuItem>
                                <MenuItem key="arabic" value="arabic">
                                    <Checkbox checked={agentValue?.languages?.includes("arabic") ?? false} />
                                    <ListItemText primary="Arabic" />
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label htmlFor="Generate Photos" className="form-label mb-3 ">{t("propertyDetails.generatePhotos")}</label>
                        <div className='profile-upload'>
                            <div><img src={agentValue?.image} style={{ display: "inline" }} />
                                Image.PNG</div>
                            <label htmlFor="Portrait1">
                                <input type="file" id="Portrait1" style={{ display: 'none' }} accept=" image/*" onChange={handleChangeImgAgent} />
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.53999 19.5196C4.92999 19.5196 4.35999 19.3096 3.94999 18.9196C3.42999 18.4296 3.17999 17.6896 3.26999 16.8896L3.63999 13.6496C3.70999 13.0396 4.07999 12.2296 4.50999 11.7896L12.72 3.09956C14.77 0.929561 16.91 0.869561 19.08 2.91956C21.25 4.96956 21.31 7.10956 19.26 9.27956L11.05 17.9696C10.63 18.4196 9.84999 18.8396 9.23999 18.9396L6.01999 19.4896C5.84999 19.4996 5.69999 19.5196 5.53999 19.5196ZM15.93 2.90956C15.16 2.90956 14.49 3.38956 13.81 4.10956L5.59999 12.8096C5.39999 13.0196 5.16999 13.5196 5.12999 13.8096L4.75999 17.0496C4.71999 17.3796 4.79999 17.6496 4.97999 17.8196C5.15999 17.9896 5.42999 18.0496 5.75999 17.9996L8.97999 17.4496C9.26999 17.3996 9.74999 17.1396 9.94999 16.9296L18.16 8.23956C19.4 6.91956 19.85 5.69956 18.04 3.99956C17.24 3.22956 16.55 2.90956 15.93 2.90956Z" fill="#282828" />
                                    <path d="M17.3404 10.9498C17.3204 10.9498 17.2904 10.9498 17.2704 10.9498C14.1504 10.6398 11.6404 8.26985 11.1604 5.16985C11.1004 4.75985 11.3804 4.37985 11.7904 4.30985C12.2004 4.24985 12.5804 4.52985 12.6504 4.93985C13.0304 7.35985 14.9904 9.21985 17.4304 9.45985C17.8404 9.49985 18.1404 9.86985 18.1004 10.2798C18.0504 10.6598 17.7204 10.9498 17.3404 10.9498Z" fill="#282828" />
                                    <path d="M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H21C21.41 21.25 21.75 21.59 21.75 22C21.75 22.41 21.41 22.75 21 22.75Z" fill="#282828" />
                                </svg>
                            </label>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <div className="padd-0-20">
                    <button type="button" className={`button-dash back-746AFF color-FFFFFF border-746AFF padd-15-30 ${agentValue.email && agentValue.fullName && agentValue.image && agentValue.languages && agentValue.phoneNumber ? "" : "disabled"}`} onClick={HandleAddAgent}>{t("propertyDetails.add")}</button>
                </div>
            </DialogActions>
        </BootstrapDialog>
    </>
    )
}

export default AddAgent;
